<template>
  <Portlet :class="['main-portlet', $route.name]" :fullHeight="true" :headSeparator="true">
    <template slot="Title">
      <router-view name="subPageHeader"></router-view>
    </template>
    <template slot="Options">
      <router-view name="pageActions"></router-view>
    </template>
    <template slot="PortletNav">
      <router-view name="pageSubMenu"></router-view>
        <Pagination 
            v-if="isDetailPage"
            :pagination="pagination"
            :sizes="[100, 250, 500, 1000]"
            @page="handlePagination"
            @page-size="handlePageSize"
        />
        <!-- <span class="little-badge paging-helper">
           {{(pagination || {count:0}).count}} tracks</span>
        <b-pagination
            v-if="pagination && pagination.pageCount > 1"
            v-model="currentPage"
            :total-rows="pagination.count"
            :per-page="pagination.pageSize"
            aria-controls="my-table"
        ></b-pagination> -->
    </template>
    <template slot="Content">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
      <!-- Modal Edition -->
      <BoxEditionCard :boxUid="editedBoxUid" v-if="isEditingBox"/>
      <BoxRemovalCard ref="modalRemoval" v-if="deletingBox" :boxUid="deletingBox ? deletingBox.uid : null" :displayData="true" />
      <BoxTrackRemovalCard ref="modalTrackRemoval" :tracks="deletingTracks ? deletingTracks : null" :box="currentBox ? currentBox : null" />
    </template>
  </Portlet>
</template>
<style scoped lang="scss">

</style>
<script>
import Vue from "vue";
import router from "@/router/index.js";
import Portlet from "@/components/common/Portlet";
import BoxSectionMenu from "./BoxSectionMenu.vue";
import Constants from "@/store/constants";
import Translations from "@/store/translations";
import EventBus from "@/eventbus";
import BoxEditionCard from "../Boxes/BoxEditionCard.vue";
import BoxRemovalCard from "./BoxRemovalCard.vue";
import BoxTrackRemovalCard from "./BoxTrackRemovalCard.vue";
import Pagination from '@/components/common/Pagination'
import store from '@/store/index.js';

import { mapState } from "vuex";
export default {
  name: "MasterBoxes",
  store,router,
  components: {
    Portlet,
    BoxSectionMenu,
    BoxEditionCard,
    BoxRemovalCard,
    BoxTrackRemovalCard,
    Pagination
  },
  created() {
    EventBus.$on("onBoxEdition", this.editBox);
    EventBus.$on("onBoxEditionEnded", this.stopEditBox);
    EventBus.$on("onBoxDelete", this.onBoxDelete);
    EventBus.$on("onBoxDeleted", this.onBoxDeleted);
    EventBus.$on("onBoxTrackDelete", this.onBoxTrackDelete);
  },
  watch:{
    'currentPage':async function(to, from){
        console.log("Page Changed : reload page tracks",to)
        EventBus.$emit("onTracksSearch", to);
        // await this.$store.dispatch('Boxes/getTrackList', {
        //     stationUid: this.$route.params.stationUid,
        //     boxUid: this.$route.params.boxUid,
        //     page:to
        // });
    }
  },
  computed: {
    Constants: () => Constants,
    Translations: () => Translations,
    ...mapState({
        pagination: state => Object.assign({},state.Boxes.pagination)
    })
    ,isDetailPage() { return this.$route.name == "BoxDetails"; }
  },
  data() {
    return {
      deletingBox: null,
      deletingTracks: null,
      currentBox: null,
      editedBoxUid: null,
      isEditingBox: false,
      deletedBoxUid: null,
      isDeletingBox: false,
      currentPage: (this.pagination||{page:1}).page || 1
    };
  },
  methods: {
    handlePagination (page) {
        EventBus.$emit("onTracksSearch", page)
    },
    handlePageSize (pageSize) {
        this.$store.dispatch('Boxes/setPaginationPageSize', pageSize)
        EventBus.$emit("onTracksSearch", 1)
    },
    onBoxDelete(box) {
      this.deletingBox = box;
      if (this.$refs["modalRemoval"]) this.$refs["modalRemoval"].show();
    },
    onBoxDeleted() {
      this.deletingBox = null;
      this.$store.dispatch("loadStationBoxes", this.$store.state.currentStationUid);
      if (this.$refs["modalRemoval"]) this.$refs["modalRemoval"].hide();

      // redirect to boxes home
      this.$router.push({name:'BoxList', params:{boxType:'MUSIC'}})

    },
    onBoxTrackDelete(track, box) {
      this.deletingTracks = Array.isArray(track) ? track : [track]
      this.currentBox = box;

      if (this.$refs["modalTrackRemoval"]) {
        // console.log('in if track removal');
        this.$refs["modalTrackRemoval"].show();
      }
    },
    editBox: function(boxUid) {
      this.editedBoxUid = boxUid;
      this.isEditingBox = true;
    },
    stopEditBox: function() {
      this.isEditingBox = false;
    }
  }
};
</script>


